import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CompanyInputComponent } from './company-input.component';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { DebounceDirectiveModule } from '@shared/directives/debounce/debounce.module';



@NgModule({
  declarations: [
    CompanyInputComponent
  ],
  imports: [
    CommonModule,
    MatAutocompleteModule,
    DebounceDirectiveModule
  ],
  exports: [
    CompanyInputComponent
  ]
})
export class CompanyInputModule { }
